export default function getData(rating) {
  if (rating === void 0) {
    rating = {};
  }
  return {
    aggregateRating: {
      '@context': 'https://schema.org',
      '@type': 'AggregateRating',
      reviewCount: rating.count,
      ratingValue: rating.value
    }
  };
}